import { Form, Formik } from "formik";
import CleButton from "@cle/components/CleButton";
import InputErrorMessage from "@/components/error/InputErrorMessage";
import InputField from "@/components/form/InputField";
import IsRequired from "@/components/form/IsRequired";
import { underskrivValidationSchema } from "@/util/validationSchema/common";

export type ReportReceiptEmailValues = {
  email: string;
  email2: string | undefined;
};

type ReportReceiptEmailStepProps = {
  errorMessage?: string | null;
  isSubmitting?: boolean;
  onCancel: () => void;
  onSubmit: (values: ReportReceiptEmailValues) => void;
};

const ReportReceiptEmailStep = ({
  errorMessage = null,
  isSubmitting = false,
  onCancel,
  onSubmit,
}: ReportReceiptEmailStepProps) => {
  return (
    <Formik
      validationSchema={underskrivValidationSchema}
      initialValues={{ email: "", email2: "" }}
      onSubmit={(values) => onSubmit(values)}
    >
      {(props) => {
        const { dirty, errors, handleSubmit, values } = props;
        const hasErrors = Boolean(errors.email || errors.email2);

        return (
          <Form onSubmit={handleSubmit}>
            <div>
              <h2 className="display-4 fw-semibold mb-2">
                Kvittering på e-mail
                <IsRequired />
              </h2>
              <p>
                I tilfælde af spørgsmål kan Advokatsamfundet kontakte mig på
                e-mail:
              </p>

              <div className="mt-2 mb-4">
                <InputField
                  config={{
                    component: "textinput",
                    id: "email",
                    initialValue: "",
                    placeholder: "E-mailadresse",
                  }}
                  formik={props}
                />
                <InputErrorMessage value={errors.email} />
              </div>

              <p>
                Du kan indtaste en ekstra mailadresse, hvis mailkvitteringen
                også skal sendes til f.eks. din HR-afdeling.
              </p>
              <div className="mt-2 mb-4">
                <InputField
                  config={{
                    component: "textinput",
                    id: "email2",
                    initialValue: "",
                    placeholder: "Ekstra e-mailadresse",
                  }}
                  formik={props}
                />
                <InputErrorMessage value={errors.email2} />
              </div>

              <p>
                Advokatsamfundet fremsender en kvittering for din indberetning
                til ovenstående e-mailadresse.
              </p>

              {errorMessage ? (
                <div className="alert alert-warning" role="alert">
                  {errorMessage}
                </div>
              ) : null}

              <div className="d-flex justify-content-between gap-3">
                <CleButton
                  id="cle-cancel-report-receipt-email"
                  variant="outline"
                  type="button"
                  disabled={isSubmitting}
                  onClick={onCancel}
                >
                  Annuller
                </CleButton>
                <CleButton
                  id="cle-confirm-report-submit"
                  type="submit"
                  disabled={
                    !dirty || !values.email || hasErrors || isSubmitting
                  }
                >
                  Godkend og indsend
                </CleButton>
              </div>
            </div>
          </Form>
        );
      }}
    </Formik>
  );
};

export default ReportReceiptEmailStep;
